import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/y7eqj8yu_logo%20rise.jpg';

export const Footer = () => (
  <footer className="bg-stone-900 text-stone-300 pt-20 pb-10" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10 mb-16">
        {/* Brand block */}
        <div className="md:col-span-4 space-y-5">
          <div className="bg-white rounded-2xl p-4 inline-block shadow-md">
            <img
              src={LOGO_URL}
              alt="Rise & Shine Learning Zone"
              className="h-20 md:h-24 w-auto"
              data-testid="footer-logo"
            />
          </div>
          <p className="text-[15px] leading-relaxed text-stone-400 max-w-sm">
            Un espacio donde cada niño puede brillar con atención personalizada y apoyo académico integral en Dorado, Puerto Rico.
          </p>
          <div className="w-12 h-[3px] bg-[#d3b163] rounded-full"></div>
        </div>

        <div className="md:col-span-2">
          <h3 className="font-semibold text-white text-base mb-5 tracking-wide">Enlaces</h3>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-[#d3b163] transition-colors">Inicio</Link></li>
            <li><Link to="/sobre-nosotros" className="hover:text-[#d3b163] transition-colors">Sobre Nosotros</Link></li>
            <li><Link to="/ofrecimientos" className="hover:text-[#d3b163] transition-colors">Ofrecimientos</Link></li>
            <li><Link to="/informacion-admision" className="hover:text-[#d3b163] transition-colors">Admisión</Link></li>
            <li><Link to="/galeria" className="hover:text-[#d3b163] transition-colors">Galería</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h3 className="font-semibold text-white text-base mb-5 tracking-wide">Servicios</h3>
          <ul className="space-y-3 text-sm">
            <li><Link to="/ofrecimientos#programa-k12" className="hover:text-[#d3b163] transition-colors">Programa K-12</Link></li>
            <li><Link to="/ofrecimientos#consultoria" className="hover:text-[#d3b163] transition-colors">Consultoría</Link></li>
            <li><Link to="/articulos" className="hover:text-[#d3b163] transition-colors">Artículos</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h3 className="font-semibold text-white text-base mb-5 tracking-wide">Contacto</h3>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-[#43b6b8]" />
              <span>Dorado, Puerto Rico</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 flex-shrink-0 text-[#43b6b8]" />
              <div className="flex flex-col">
                <a href="tel:+17873625354" className="hover:text-[#d3b163] transition-colors">(787) 362-5354</a>
                <a href="tel:+17873625352" className="hover:text-[#d3b163] transition-colors">(787) 362-5352</a>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 flex-shrink-0 text-[#43b6b8]" />
              <a href="mailto:info@riseandshinezone.com" className="hover:text-[#d3b163] transition-colors break-all">
                info@riseandshinezone.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-stone-500">
        <p>&copy; {new Date().getFullYear()} Rise & Shine Learning Zone LLC. Todos los derechos reservados.</p>
        <p className="text-xs tracking-wide">Educando con propósito en Dorado, PR</p>
      </div>
    </div>
  </footer>
);
